import React, { useState, useEffect } from 'react';
import styles from './style.module.scss';
import { Button, Dialog, DialogTitle, DialogContent, IconButton, Container, DialogActions, styled, CircularProgress } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from '@material-ui/icons/Close';
import { exportCSVFile } from '../../utils/commonFunctions';
import { Delete } from '@material-ui/icons';

const UplaodFileModal = (props) => {
    const [selectedFile, setSelectedFile] = useState();

    const useStyles = makeStyles({
        root: {
            "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                borderColor: "#e9ecef",
                borderRadius: '30px',
                boxShadow: 'rgb(17 17 26 / 5%) 0px 1px 0px, rgb(17 17 26 / 10%) 0px 0px 8px'
            },
            "& .MuiOutlinedInput-adornedStart": {
                paddingLeft: '25px'
            },
            "& .MuiInputAdornment-positionStart": {
                marginRight: '18px'
            },
            "& .MuiOutlinedInput-adornedEnd": {
                paddingRight: '25px'
            },
            "& .MuiDialog-container": {
                alignItems: 'start',
                display: 'flex'
            }
        },
        paper: {
            "&  .MuiDialog-scrollPaper": {
                alignItems: 'start'
            }, width: 'calc(100% - 100px)'
        },
        select: {
            "&:focus": {
                backgroundColor: "white"
            }
        }
    });
    const classes = useStyles();
    const Input = styled('input')({
        display: 'none',
    });

    useEffect(() => {
        setSelectedFile(null);
    }, [props.show]);

    const fileSelected = (e) => {
        setSelectedFile(e.target.files[0]);
    }

    const downloadSampleFile = () => {
        let headers = {
            customerName: 'name',
            phoneNumber: 'phoneNumber'
        };

        let itemsFormatted = [];
        itemsFormatted.push({
            customerName: 'Customer Name',
            phoneNumber: '1234567890'
        })

        let fileTitle = "Sample-customer-file";
        exportCSVFile(headers, itemsFormatted, fileTitle);

    }

    return <div className={styles.mainContainer}>
        <Dialog classes={{ paper: classes.paper, root: classes.root }} maxWidth="sm" open={props.show} onClose={() => props.handleClose()} >
            <DialogTitle id="customized-dialog-title" onClose={() => props.handleClose()} className={styles.modalTitle}>
                <div className="d-flex justify-content-between align-items-center">
                    <div>
                        <div className="mb-0">Customer file upload</div>
                    </div>
                    <div>
                        <IconButton className={styles.closeBtn} onClick={() => props.handleClose()}>
                            <CloseIcon className={styles.searchClose} />
                        </IconButton>
                    </div>
                </div>
            </DialogTitle>
            <DialogContent className="mt-4 mb-4" >
                <Container maxWidth="md">
                    <div className={styles.uploadDiv}>
                        <label htmlFor="contained-button-file">
                            <Input accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" id="contained-button-file" type="file" onChange={(e) => fileSelected(e)} />
                            <Button variant="contained" color="primary" component="span">
                                Browse file
                            </Button>
                        </label>
                        <small className="text-muted d-block pt-2 pb-2">*Supported file formats: XLSX, XLS, CSV</small>
                    </div>
                    {
                        selectedFile && selectedFile.name ?
                            <div className="d-flex align-items-center justify-content-center pt-4">
                                <h6 className="mb-0">{selectedFile && selectedFile.name}</h6>
                                <Delete className="ml-3" style={{ fontSize: '18px', color: 'red', cursor: 'pointer' }} onClick={() => setSelectedFile(null)} />
                            </div>

                            : null
                    }
                </Container>
            </DialogContent>
            <DialogActions className="d-flex justify-content-between">
                <Button color="primary" className="m-1" onClick={() => downloadSampleFile()}>Download sample file</Button>
                <Button variant="contained" color="primary" disabled={!selectedFile} onClick={() => !props.uploadLoader && selectedFile ? props.uploadCustomerFile(selectedFile) : null}>
                    Upload
                    {props.uploadLoader ? <CircularProgress className="ml-2" style={{ color: 'white' }} size={15} /> : null}
                </Button>
            </DialogActions>
        </Dialog>
    </div>
}

export default UplaodFileModal;